//#region Globals

/* Supported Domains */
export const DOMAINS = ['rappi.com', 'rappisupport.com'];

/* Default Date Time Format */
export const DATETIME_DEFAULT_FORMAT = 'DD/MM/yyyy, HH:mm:ss';

/* Default Date Format */
export const DATE_DEFAULT_FORMAT = 'dd/MM/yyyy';

/* Decimal Format */
export const DECIMAL_DEFAULT_FORMAT = '1.0-2';

/* Secondary Default Format */
export const CURRENCY_SECONDARY_DEFAULT_FORMAT = 'USD';

/* Supported Countries - HTML use */
export enum COUNTRY {
  ALL = 'ALL',
  CO = 'CO',
  PE = 'PE',
  BR = 'BR',
  CL = 'CL',
  MX = 'MX',
}

/* TimeZones */
export const COUNTRY_TZ = {
  ALL: 'America/Mexico_City',
  CO: 'America/Bogota',
  CL: 'America/Santiago',
  MX: 'America/Mexico_City',
  BR: 'America/Sao_Paulo',
  AR: 'America/Argentina/Buenos_Aires',
  UY: 'America/Montevideo',
  PE: 'America/Lima',
  CR: 'America/Costa_Rica',
  BO: 'America/La_Paz',
};

/* Supported Languages */
export type LANGUAGE = 'EN' | 'ES' | 'PT';

export enum LANGS {
  ES = 'ES',
  EN = 'EN',
  PT = 'PT',
}

export enum USER_TYPE {
  PJ = 'PJ',
  PN = 'PN',
}

/* Supported search user type */
export const SEARCH_BY_USER_TYPE = [
  {
    key: 'PN',
    value: 'Persona Natural',
    country: COUNTRY.CO,
    svgIcon: 'natural',
  },
  {
    key: 'PJ',
    value: 'Persona Juridica',
    country: COUNTRY.CO,
    svgIcon: 'business',
  },
];

/* Supported search By values */
export const SEARCH_BY = [
  {
    key: 'userId',
    value: 'Rappi ID',
    country: COUNTRY.ALL,
    userType: USER_TYPE.PN,
  },
  {
    key: 'rppUserId',
    value: 'RppUser ID',
    country: COUNTRY.ALL,
    userType: USER_TYPE.PN,
  },
  {
    key: 'phone',
    value: 'Phone',
    country: COUNTRY.ALL,
    userType: USER_TYPE.PN,
  },
  {
    key: 'email',
    value: 'Email',
    country: COUNTRY.ALL,
    userType: USER_TYPE.PN,
  },
  {
    key: 'RUT',
    value: 'RUT',
    country: COUNTRY.CL,
    userType: USER_TYPE.PN,
  },
  {
    key: 'CC',
    value: 'CC',
    country: COUNTRY.CO,
    userType: USER_TYPE.PN,
  },
  {
    key: 'CE',
    value: 'CE',
    country: COUNTRY.CO,
    userType: USER_TYPE.PN,
  },
  {
    key: 'RG',
    value: 'RG',
    country: COUNTRY.BR,
    userType: USER_TYPE.PN,
  },
  {
    key: 'CPF',
    value: 'CPF',
    country: COUNTRY.BR,
    userType: USER_TYPE.PN,
  },
  {
    key: 'DNI',
    value: 'DNI',
    country: COUNTRY.PE,
    userType: USER_TYPE.PN,
  },
  {
    key: 'rppBusinessId',
    value: 'Business Id',
    country: COUNTRY.CO,
    userType: USER_TYPE.PJ,
  },
  {
    key: 'rppBusinessEmail',
    value: 'Business Email',
    country: COUNTRY.CO,
    userType: USER_TYPE.PJ,
  },
  {
    key: 'nit',
    value: 'NIT',
    country: COUNTRY.CO,
    userType: USER_TYPE.PJ,
  },
  {
    key: 'prospectId',
    value: 'Prospect Id',
    country: COUNTRY.CO,
    userType: USER_TYPE.PJ,
  },
];

/* Readonly Value Types */
export type READONLY_VALUE_TYPE =
  | 'number'
  | 'icon'
  | 'date'
  | 'dateTime'
  | 'currency'
  | 'currency-secondary'
  | 'iconText'
  | 'status'
  | 'statusIcon'
  | 'link'
  | 'boolean'
  | 'img'
  | 'content'
  | 'default'
  | 'percentage'
  | 'check';

/* Readonly Display Type */
export type READONLY_DISPLAY_TYPE = 'row' | 'col';

/* Sidenav Components */
export enum SIDENAV_COMPONENT {
  //#region Account

  ACCOUNT_LIMITS = 'ACCOUNT_LIMITS',
  ACCOUNT_MOVEMENT_DETAIL = 'ACCOUNT_MOVEMENT_DETAIL',
  ACCOUNT_FREEZE_DETAIL = 'ACCOUNT_FREEZE_DETAIL',
  BREB_KEYS = 'BREB_KEYS',

  //#endregion

  //#region Contracts

  CONTRACT_CREDIT_LINE = 'CONTRACT_CREDIT_LINE',
  CONTRACT_CARD_HISTORY = 'CONTRACT_CARD_HISTORY',
  CONTRACT_CARD_SETTINGS = 'CONTRACT_CARD_SETTINGS',
  CONTRACT_REWARDS_DETAIL = 'CONTRACT_REWARDS_DETAIL',
  CONTRACT_REFERRALS_LIST = 'CONTRACT_REFERRALS_LIST',
  CONTRACT_CARD_PAYMENT_SPEI_DETAIL = 'CONTRACT_CARD_PAYMENT_SPEI_DETAIL',
  CONTRACT_CARD_PAYMENT_DETAIL = 'CONTRACT_CARD_PAYMENT_DETAIL',
  CONTRACT_CASH_WITHDRAWAL = 'CONTRACT_CASH_WITHDRAWAL',
  BILL_PAYMENTS = 'BILL_PAYMENTS',
  CONTRACT_RESTRUCTURE = 'CONTRACT_RESTRUCTURE',
  CONTRACT_CARD_DETAIL = 'CONTRACT_CARD_DETAIL',
  CONTRACT_TRANSACTION_DETAIL = 'CONTRACT_TRANSACTION_DETAIL',

  CARD_PAYMENT_CYCLE = 'CARD_PAYMENT_CYCLE',

  ACCOUNT_USER_VAULT = 'ACCOUNT_USER_VAULT',

  //#endregion

  //#region Clarification

  CLARIFICATION_DETAIL = 'CLARIFICATION_DETAIL',

  //#endregion

  //#region Orders

  ORDER_DETAIL = 'ORDER_DETAIL',

  //#endregion

  //#region Onboarding

  ONBOARDING_IDENTIFICATIONS = 'ONBOARDING_IDENTIFICATIONS',
  ONBOARDING_LOCATION = 'ONBOARDING_LOCATION',

  //#endregion

  //#region Onboarding
  CALL_DETAIL = 'CALL_DETAIL',
  //#endregion

  //#region Business Team
  BUSINESS_TEAM_DETAIL = 'BUSINESS_TEAM_DETAIL',
  //#endregion
}

//#endregion

//#region Status

export enum STATUS {
  DEFAULT = 'DEFAULT',
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  BLOCKED = 'BLOCKED',
  COMPLETE = 'COMPLETE',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
  CANCEL = 'CANCEL',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  DELETED = 'DELETED',
  DISABLE = 'DISABLE',
  DISABLED = 'DISABLED',
  ENABLE = 'ENABLE',
  ENABLED = 'ENABLED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  FROZEN = 'FROZEN',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_CLOSING = 'IN_CLOSING',
  MISSING = 'MISSING',
  PENDING = 'PENDING',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  RETRY = 'RETRY',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
  ERROR = 'ERROR',
  ACTIVATED = 'ACTIVATED',
  DENIED = 'DENIED',
  SUCCESS = 'SUCCESS',

  //REQUIRES_ADDITIONAL_REVIEW = 'REQUIRES_ADDITIONAL_REVIEW',
  STARTED = 'STARTED',
  CANCELED_WITHDRAWAL = 'CANCELED_WITHDRAWAL',
  SCHEDULED = 'SCHEDULED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export const enum CALL_STATUS {
  NOT_MAPPED = 'NOT_MAPPED',
  COMPLETED = 'COMPLETED',
  NO_ANSWER = 'NO_ANSWER',
  ERROR = 'ERROR',
}

export enum CONTRACT_STATE {
  ACTIVE = 'ACTIVE',
  CANCEL = 'CANCEL',
  BLOCKED = 'BLOCKED',
  INACTIVE = 'INACTIVE',
  ERROR = 'ERROR',
  REPLACED = 'REPLACED',
  FROZEN = 'FROZEN',
  FROZEN_REJECT = 'FROZEN_REJECT',
  DELIVERED = 'DELIVERED',
  DELIVERED_BY_EXTERNAL = 'DELIVERED_BY_EXTERNAL',
  CREATED = 'CREATED',
}

export enum ACCOUNT_STATUS {
  ENABLE = 'ENABLE',
  CLOSED = 'CLOSED',
}

export enum REFERRAL_STATUS {
  SUCCESS = 'Exitoso',
  INVALID = 'No válido',
  PENDING = 'Pendiente',
}

//#endregion

//#region Scopes

export enum SCOPE {
  //ACCESS_LEVEL
  ACCESS_LEVEL_0 = 'access:level:0',
  ACCESS_LEVEL_1 = 'access:level:1',
  ACCESS_LEVEL_2 = 'access:level:2',

  /**
   * @deprecated Module access not necessary
   */
  //Modules Access
  // ACCESS_RESUME = 'access:customer_resume',
  // ACCESS_WIDGET = 'access:widget',
  // ACCESS_ONBOARDING = 'access:onboarding',
  // ACCESS_CREDIT = 'access:credit',
  // ACCESS_DEBIT = 'access:debit',
  // ACCESS_ACCOUNT = 'access:account',
  // ACCESS_ORDER = 'access:order',
  // ACCESS_CALL = 'access:call',
  // ACCESS_NOTIFICATION = 'access:notification',
  // ACCESS_BILL_PAYMENT = 'access:bill_payment',
  //Actions
  // ACTION_BLOCK_CONTRACT = 'action:block_contract',
  ACTION_FACE_AUTH = 'a:user:faceauth',
}

//#endregion

//#region Types

export enum CONTRACT_TYPE {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  CREDIT_ADD = 'CREDIT_ADD',
}

export enum CARD_TYPE {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL',
}

export const enum CARD_STATE {
  ACTIVE = 'ACTIVE',
  CANCEL = 'CANCEL',
  REPLACED = 'REPLACED',
  FROZEN = 'FROZEN',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
}

export const enum CARD_SUBSTATE {
  DELIVERED = 'DELIVERED',
  REQUESTED = 'REQUESTED',
  DELIVERED_BY_EXTERNAL = 'DELIVERED_BY_EXTERNAL',
  SHIPPED = 'SHIPPED',
}

export const enum ACCOUNT_TYPE {
  RAPPIPAY = 'RAPPIPAY',
  RAPPIBANK = 'RAPPIBANK',
}

export const enum ACTION_STATUS {
  PENDING = 'PENDING',
  //IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

export const enum PRODUCT_TYPE {
  ACCOUNT = 'ACCOUNT',
  CREDIT_CONTRACT = 'CREDIT_CONTRACT',
  DEBIT_CONTRACT = 'DEBIT_CONTRACT',
  CREDIT_ADD = 'CREDIT_ADD',
  CREDIT_ADD_CONTRACT = 'CREDIT_ADD_CONTRACT',
  CONTRACT = 'CONTRACT',
  INSTALLMENTS_LOANS = 'INSTALLMENTS_LOANS',
  INSURANCES = 'INSURANCES',
}

export const enum BLOCK_REASON_TYPE {
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK',
}

export const enum PARAM_BLOCK_REASON {
  SCOPE = 'scope',
  CONTRACT_TYPE = 'contractType',
  PRODUCT_TYPE = 'productType',
  REASON_TYPE = 'reasonType',
  ACCOUNT_ORIGIN = 'accountCode',
  ACTION = 'action',
}

//#endregion

//#region Origins

export enum ACCOUNT_ORIGIN {
  RAPPIPAY = 'RAPPIPAY',
  COBIS = 'COBIS',
  REDEBAN = 'REDEBAN',
}

export enum CREDIT_CARD_ORIGIN {}

//#endregion

//#region Clarification

export enum CLARIFICATION_RESOLUTION_STATUS {
  UNDER_REVIEW = 'UNDER_REVIEW',
}

export enum CLARIFICATION_TYPE {
  DISPUTE = 'DISPUTE',
}

//#endregion

//#region Widget Filter

export enum FILTER_KEY {
  CREDIT = 'CREDIT',
  ACCOUNT = 'ACCOUNT',
  ONBOARDING = 'ONBOARDING',
  KYC = 'KYC',
  ORDER = 'ORDER',
  PERSONAL_LOANS = 'PERSONAL_LOANS',
  BILL_PAYMENTS = 'BILL_PAYMENTS',
  CALLS = 'CALLS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  POCKETS = 'POCKETS',
}

//#endregion

export enum COMPONENT {
  CONTRACT_WIDGET = 'Contract_Widget',
  ACCOUNT_WIDGET = 'Account_Widget',
  MOVEMENT_LIST_WIDGET = 'Movement_List_Widget',
  CARD_LIST_WIDGET = 'Card_List_Widget',
  PAYMENT_WIDGET = 'Payment_Widget',
  TRANSACTION_LIST_WIDGET = 'Transaction_List_Widget',
  KYC_WIDGET = 'Kyc_Widget',
  ONBOARDING_WIDGET = 'Onboarding_Widget',
  POCKETS_WIDGET = 'Pocket_Widget',
  ORDER_LIST_WIDGET = 'Order_List_Widget',
}

export interface IProductAvailable {
  available: boolean;
  type: PRODUCT_TYPE;
  rppUserId: string;
  svgIcon: string;
  path: string;
}

export enum INSTALLMENT_LOAN_STATE {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  PAST_DUE_LOW = 'PAST_DUE_LOW',
  PAST_DUE_HIGH = 'PAST_DUE_HIGH',
}

export enum INSURANCE_STATE {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  ARREARS = 'ARREARS',
  TO_CANCEL = 'TO_CANCEL',
  CLAIM = 'CLAIM',
}
